import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  styled,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ReactNode } from 'react';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: 'none',
  '&::before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-root': {
    padding: theme.spacing(
      theme.spacingSizes.md,
      theme.spacingSizes.md,
      0,
      theme.spacingSizes.md,
    ),
  },
  '& .MuiAccordionDetails-root': {
    padding: theme.spacing(theme.spacingSizes.md),
  },
}));

type Props = {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
};

const OutlinedAccordion: React.FC<Props> = ({
  title,
  children,
  defaultExpanded = false,
}) => (
  <StyledAccordion defaultExpanded={defaultExpanded}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="body2">{title}</Typography>
    </AccordionSummary>
    <AccordionDetails>{children}</AccordionDetails>
  </StyledAccordion>
);

export default OutlinedAccordion;
